module.exports = __webpack_public_path__ + "static/media/IMG-3.13e98567.jpg";